import { get, post, put } from './api.service';

const base_url = 'sales/v1/invoices';

export const getAll = (params: {
        page?: number,
        per_page?: number,
        limit?: number,
        search?: string,
        status?: string,
        saleUuid?: string,
        customer_id?: number,
        order?: string,
        date?: string,
        due_date?: string,
        period?: string,
        periodDueDate?: string,
} = {}) => {
    const queryString = Object.keys(params)
        .filter(key => params[key as keyof typeof params])
        .map(key => {
            return `${key}=${params[key as keyof typeof params]}`;
        }).join('&');

    let url = queryString ? base_url + `?${queryString}` : base_url;

    return get(url);
}

export const getById = (uuid: string) => {
    return get(`${base_url}/${uuid}`);
}

export const create = (data: object) => {
    return post(base_url, data);
}

export const updateStatus = (data: { values: object, uuid: string }) => {
    return put(`${base_url}/${data.uuid}/status`, data.values);
}

export const sendInvoice = (data: { values: object, uuid: string }) => {
    return post(`${base_url}/${data.uuid}/sendInvoice`, data.values);
}
